import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ConditionsService = {
    list: async () => axios.post(API_URL + "/conditions/list").then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getCondition/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/conditions`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/conditions/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/conditions/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default ConditionsService;
